import { Col, Row } from 'react-styled-flexboxgrid';
import { useSwipeable } from 'react-swipeable';
import styled from 'styled-components';

import { Avatar } from '../../Global/Atomics/Avatar';
import Box from '../../Global/Atomics/Box';
import { Container } from '../../Global/Atomics/Container';
import { Heading } from '../../Global/Atomics/Heading';
import { Paragraph } from '../../Global/Atomics/Paragraph';
import CustomIcon from '../../Global/Icons/CustomIcon';

import { useTranslationContext } from '../../../contexts/TranslationContext';

const Circle = styled(Avatar)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

type TProps = {
    maxTab: number;
    tab: number;
    setTab: (num: number) => void;
}

const NoIncidents = ({ maxTab, tab, setTab }: TProps) => {
    const { resources } = useTranslationContext();

    const handlers = useSwipeable({
        onSwipedLeft: () => {
            tab < maxTab - 1 && setTab(tab + 1);
            document.getElementById('tabs-nav')!.scrollTo({
                top: 0,
                left: document.getElementById('tabs-nav')!.scrollLeft + 40,
                behavior: 'smooth'
            });
        },
        onSwipedRight: () => {
            tab > 0 && setTab(tab - 1)
            document.getElementById('tabs-nav')!.scrollTo({
                top: 0,
                left: document.getElementById('tabs-nav')!.scrollLeft - 40,
                behavior: 'smooth'
            });
        }
    });

    return (
        <Box display="flex" flexDirection='column' justifyContent="center" mt="lg" pt="md" {...handlers}>
            <Circle border="none" position="relative" bg="white" size={200}>
                <Avatar border="none" position="relative" bg="green-nova" size={50} margin="43px auto 0 auto">
                    <CustomIcon icon="SuccessIcon" customColor="white" width={28} height={28} />
                </Avatar>
                <CustomIcon icon="CampusAll" />
            </Circle>

            <Container>
                <Row center="xs">
                    <Col xs={9}>
                        <Heading level={1} typography="text-l-bold" textAlign='center' mt="lg" mb="md">{resources.label.noIncidents}</Heading>
                        <Paragraph typography="text-s-medium" textAlign="center">{resources.label.noIncidentInThisState}</Paragraph>
                    </Col>
                </Row>
            </Container>

        </Box>
    );
};

export default NoIncidents;
